<template>
  <button
    id="day-night"
    type="button"
    :aria-label="$t('theme.toggle')"
    :aria-pressed="ui.isLightTheme"
    :class="{ light: ui.isLightTheme }"
    @click="ui.toggleTheme()"
  >
    <span class="ocean">
      <span class="ship">
        <span class="mast">
          <span class="sail-1" />
          <span class="sail-2" />
        </span>
      </span>
    </span>
    <span class="moon" />
    <span class="sun" />
  </button>
</template>

<script setup lang="ts">
import { useUiStore } from '@/stores/ui';

const ui = useUiStore();
</script>

<style scoped lang="scss">
/* Paridade 1:1 — portfolio-2020/src/App.vue #day-night */
#day-night {
  cursor: pointer;
  position: relative;
  z-index: 1;
  width: 90px;
  height: 50px;
  background: #00001a;
  padding: 0;
  margin: 0;
  border: 0;
  border-radius: 50px;
  overflow: hidden;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  transition: all 0.5s ease;

  &:focus-visible {
    outline: 2px solid #ffae00;
    outline-offset: 2px;
  }

  .ocean {
    width: 100%;
    height: 15px;
    background: #000033;
    position: relative;
    z-index: 10;
    transition: all 0.5s ease;

    .ship {
      position: absolute;
      top: -4px;
      left: 30%;
      background: #4d0000;
      width: 40px;
      height: 8px;
      transition: all 0.5s ease;

      &::before {
        content: '';
        position: absolute;
        right: -11px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 8px 11px 0 0;
        border-color: #4d0000 transparent transparent transparent;
        transition: all 0.5s ease;
      }

      &::after {
        content: '';
        position: absolute;
        left: -3px;
        bottom: 0;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 0 3px 3px;
        border-color: transparent transparent #330000 transparent;
        transition: all 0.5s ease;
      }

      .mast {
        position: absolute;
        display: block;
        top: -20px;
        left: 17px;
        background: #330000;
        width: 2px;
        height: 20px;
        transition: all 0.5s ease;

        &::before {
          content: '';
          position: absolute;
          display: block;
          top: -8px;
          left: 0.8px;
          width: 0.5px;
          height: 8px;
          background: #330000;
          transition: all 0.5s ease;
        }

        &::after {
          content: '\2620';
          position: absolute;
          display: block;
          top: -7px;
          left: 1px;
          width: 10px;
          height: 6px;
          background: #000;
          color: #fff;
          font-size: 5px;
          transition: all 0.5s ease;
        }

        .sail-1 {
          position: absolute;
          left: 3px;
          top: 0;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 17px 0 0 35px;
          border-color: transparent transparent transparent #000;
          transition: all 0.5s ease;
        }

        .sail-2 {
          position: absolute;
          left: -15px;
          top: 0;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 0 0 18px 14px;
          border-color: transparent transparent #000 transparent;
          transition: all 0.5s ease;
        }
      }
    }
  }

  .moon {
    position: absolute;
    z-index: 5;
    top: 50%;
    left: 47%;
    transform: translate(-50%, -50%);
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: #fff;
    display: block;
    opacity: 1;
    transition: all 0.5s ease;
  }

  .sun {
    position: absolute;
    z-index: 0;
    top: -100px;
    left: 70%;
    transform: translate(-50%, -50%);
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #ff0;
    display: block;
    opacity: 0;
    transition: all 0.5s ease;
  }

  &.light {
    background: #b3d9ff;

    .ocean {
      background: #1a8cff;
    }

    .moon {
      top: 100px;
      left: 60%;
      width: 90px;
      height: 90px;
      opacity: 0;
    }

    .sun {
      top: 8px;
      left: 55%;
      width: 20px;
      height: 20px;
      opacity: 1;
    }
  }
}
</style>
